import React from 'react';
import { gql } from '@apollo/client';
import { useMutation } from '@pv/common/hooks';
import { PvDialog } from '@pv/common/components';
import { enqueueSnackbar } from 'notistack';

import { FileUploader } from './FileUploader';

interface VenueDataImport {
  id: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  errorMessages: string[];
  stagingResults?: any;
  storageUrl?: string | null;
}
interface VenueDataImportFormProps {
  venueId: string;
  show: boolean;
  onClose: () => void;
  onCompleted: (venueDataImport: VenueDataImport) => void;
}

const createVenueDataImportMutation = gql`
  mutation CreateVenueDataImport($input: CreateVenueDataImportInput!) {
    createVenueDataImport(input: $input) {
      venueDataImport {
        id
        createdAt
        updatedAt
        status
        errorMessages
      }
      errors {
        message
      }
    }
  }
`;

export const VenueDataImportForm = ({
  venueId,
  show,
  onClose,
  onCompleted,
}: VenueDataImportFormProps) => {
  const [nonTripleseatEventsCsv, setNonTripleseatEventsCsv] =
    React.useState<any>(null);
  const [plannersCsv, setPlannersCsv] = React.useState<any>(null);

  const [createVenueDataImport, { loading }] = useMutation(
    createVenueDataImportMutation,
    {
      onNoErrorsCompleted: (response) => {
        const newVenueDataImport =
          response.createVenueDataImport.venueDataImport;
        onCompleted(newVenueDataImport);
        enqueueSnackbar('Data Import Created', {
          variant: 'success',
        });
        onClose();
      },
      onSomeErrorsCompleted: (resp) => {
        const errors = resp.createVenueDataImport.errors;
        errors.forEach((error: { message: string }) => {
          enqueueSnackbar(`Error creating data import: ${error.message}`, {
            variant: 'error',
          });
        });
      },
    }
  );

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const variables = {
      input: {
        venueId: venueId,
        nonTripleseatEventsCsv,
        plannersCsv,
      },
    };
    createVenueDataImport({
      variables: variables,
    });
  };

  return (
    <PvDialog
      open={show}
      onClose={onClose}
      title="Create New Data Import"
      confirmButtonText="Import Data"
      confirmButtonColor="primary"
      onConfirm={(e: any) => handleSubmit(e)}
      loading={loading}
    >
      <div>
        <p>Import data from a spreadsheet provided by the customer</p>
        <form onSubmit={handleSubmit}>
          <FileUploader
            label="Events CSV"
            fileName="nonTripleseatEventsCsv"
            fileType="csv"
            file={nonTripleseatEventsCsv}
            color={'#89D6F0'}
            onFileAttached={(file) => setNonTripleseatEventsCsv(file)}
          />
          <FileUploader
            label="Contacts CSV"
            fileName="plannersCsv"
            fileType="csv"
            file={plannersCsv}
            color={'#E8E8E8'}
            onFileAttached={(file) => setPlannersCsv(file)}
          />
        </form>
      </div>
    </PvDialog>
  );
};
